import { createContext, ReactNode, useContext, useState } from 'react';

interface TotalPlayersInSessionContextProps {
  totalPlayersInSession: number;
  setTotalPlayersInSession: (totalPlayersInSession: number) => void;
}

const TotalPlayersInSessionContext = createContext<TotalPlayersInSessionContextProps | undefined>(
  undefined
);

export const useTotalPlayersInSession = () => {
  const context = useContext(TotalPlayersInSessionContext);
  if (!context) {
    throw new Error('useTotalPlayersInSession must be used within a TotalPlayersInSessionProvider');
  }
  return context;
};

export const TotalPlayersInSessionProvider = ({ children }: { children: ReactNode }) => {
  const [totalPlayersInSession, setTotalPlayersInSession] = useState(0);
  return (
    <TotalPlayersInSessionContext.Provider
      value={{ totalPlayersInSession, setTotalPlayersInSession }}
    >
      {children}
    </TotalPlayersInSessionContext.Provider>
  );
};
